// "Show only differences" on category comparison tables.
export function initCompare(root) {
  for (const box of root.querySelectorAll?.('[data-compare-diff]') ?? []) {
    if (box.dataset.bound) continue;
    box.dataset.bound = '1';
    const table = box.closest('.compare')?.querySelector('[data-compare]');
    box.addEventListener('change', () => table?.toggleAttribute('data-diff-only', box.checked));
  }
}
